// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"094f82f9","821":"fd6f9f07"}[chunkId] + ".chunk.js";
};